import React, { useEffect, useState } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Form from "./Warehouse/Form";

// Utils
import { getAlert } from "../../../utils/SamuiUtils";

function Warehouse() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // do nothing
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const breadcrumbs = [{ label: "คลังสินค้า" }];

  return (
    <div className="WarehouseStock">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#E13F57",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <Topbar breadcrumbs={breadcrumbs} />
          <div className="container">
            <div className="page-inner" style={{ marginTop: "56px" }}>
              <Form name={"สต็อกคลังสินค้า"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Warehouse;
